/* PrimeChemical Corp. — verificador publico de licencias.
   v1 · 2026-09-15
   Vive en /pages/licencias. Antes estaba incrustado en la home; se saco de alli
   para que la home no arrastre este peso y para que el verificador tenga URL propia.
   Sin dependencias del tema principal: trae sus propios textos en los 4 idiomas. */
(function () {
  'use strict';

  const REGISTRY={
  'CP-2601-PTK':{brand:'Protein K®',product:'Creatine Monohydrate Premium',tech:'CREAPRIME™',since:'2026'},
  'LP-2602-HSP':{brand:'HiSupps®',product:'Advanced Whey System',tech:'LACTOPRIME™',since:'2026'},
  'CP-2613-HSP':{brand:'HiSupps®',product:'Flavored Creatine Series',tech:'CREAPRIME™',since:'2026'},
  'SP-2614-HSP':{brand:'HiSupps®',product:'Sugar-Free Flavor Systems',tech:'SUCRAPRIME™',since:'2026'},
  'SP-2603-GDS':{brand:'Gudslip®',product:'Sleep Gummies — sugar-free system',tech:'SUCRAPRIME™',since:'2026'},
  'CP-2615-GDS':{brand:'Gudslip®',product:'Gudsport Performance Line',tech:'CREAPRIME™',since:'2026'},
  'LP-2616-GDS':{brand:'Gudslip®',product:'Recovery Protein Systems',tech:'LACTOPRIME™',since:'2026'},
  'CP-2604-SPF':{brand:'Suprafeel®',product:'Creatine Series',tech:'CREAPRIME™',since:'2026'},
  'LP-2605-SPF':{brand:'Suprafeel®',product:'Protein Series',tech:'LACTOPRIME™',since:'2026'},
  'SP-2606-SPF':{brand:'Suprafeel®',product:'Sugar-free Series',tech:'SUCRAPRIME™',since:'2026'},
  'CP-2607-MBK':{brand:'Minute Bake®',product:'Functional Bakery — Creatine Line',tech:'CREAPRIME™',since:'2026'},
  'LP-2608-MBK':{brand:'Minute Bake®',product:'High-Protein Pastry Mixes',tech:'LACTOPRIME™',since:'2026'},
  'SP-2609-MBK':{brand:'Minute Bake®',product:'Sugar-Free Pastry Systems',tech:'SUCRAPRIME™',since:'2026'},
  'CP-2610-PRT':{brand:'Protella®',product:'Flavored Creatine Series',tech:'CREAPRIME™',since:'2026'},
  'LP-2611-PRT':{brand:'Protella®',product:'Whey & Protein Creams',tech:'LACTOPRIME™',since:'2026'},
  'SP-2612-PRT':{brand:'Protella®',product:'Sugar-Free Line',tech:'SUCRAPRIME™',since:'2026'}
  };

  var STR = {
    "en": {
      "vs_1": "QUERYING PRIMECHEMICAL REGISTRY…",
      "vs_2": "CHECKING LICENSE STATUS…",
      "vs_3": "CROSS-REFERENCING BATCH RECORDS…",
      "vs_ok": "MATCH FOUND ✓",
      "vs_ko": "NO MATCH IN REGISTRY",
      "vr_ok": "LICENSE VERIFIED",
      "vr_ko": "CODE NOT FOUND",
      "vr_code": "Registration code",
      "vr_brand": "Licensed brand",
      "vr_prod": "Product",
      "vr_tech": "Technology",
      "vr_status": "License status",
      "vr_active": "ACTIVE",
      "vr_since": "Licensed since",
      "vr_oknote": "This product is authorized to carry the seal shown above. Purity and identity of the licensed ingredient are controlled batch by batch.",
      "vr_konote": "This code is not in our license registry. Check for typos — or if the product displays one of our seals with this code, please <a href='mailto:licence@primechemicalcorp.com?subject=Code%20verification%20report'>report it to us</a>."
    },
    "es": {
      "vs_1": "CONSULTANDO EL REGISTRO PRIMECHEMICAL…",
      "vs_2": "COMPROBANDO ESTADO DE LA LICENCIA…",
      "vs_3": "CRUZANDO REGISTROS DE LOTE…",
      "vs_ok": "COINCIDENCIA ENCONTRADA ✓",
      "vs_ko": "SIN COINCIDENCIAS EN EL REGISTRO",
      "vr_ok": "LICENCIA VERIFICADA",
      "vr_ko": "CÓDIGO NO ENCONTRADO",
      "vr_code": "Código de registro",
      "vr_brand": "Marca licenciada",
      "vr_prod": "Producto",
      "vr_tech": "Tecnología",
      "vr_status": "Estado de la licencia",
      "vr_active": "ACTIVA",
      "vr_since": "Licenciada desde",
      "vr_oknote": "Este producto está autorizado a llevar el sello indicado. La pureza e identidad del ingrediente licenciado se controlan lote a lote.",
      "vr_konote": "Este código no está en nuestro registro de licencias. Revisa que esté bien escrito — y si el producto muestra uno de nuestros sellos con este código, <a href='mailto:licence@primechemicalcorp.com?subject=Verificación%20de%20código'>repórtanoslo</a>."
    },
    "fr": {
      "vs_1": "INTERROGATION DU REGISTRE PRIMECHEMICAL…",
      "vs_2": "VÉRIFICATION DU STATUT DE LICENCE…",
      "vs_3": "CROISEMENT DES REGISTRES DE LOTS…",
      "vs_ok": "CORRESPONDANCE TROUVÉE ✓",
      "vs_ko": "AUCUNE CORRESPONDANCE",
      "vr_ok": "LICENCE VÉRIFIÉE",
      "vr_ko": "CODE INTROUVABLE",
      "vr_code": "Code d'enregistrement",
      "vr_brand": "Marque licenciée",
      "vr_prod": "Produit",
      "vr_tech": "Technologie",
      "vr_status": "Statut de la licence",
      "vr_active": "ACTIVE",
      "vr_since": "Sous licence depuis",
      "vr_oknote": "Ce produit est autorisé à porter le sceau indiqué. La pureté et l'identité de l'ingrédient sous licence sont contrôlées lot par lot.",
      "vr_konote": "Ce code n'est pas dans notre registre de licences. Vérifiez la saisie — et si le produit affiche l'un de nos sceaux avec ce code, <a href='mailto:licence@primechemicalcorp.com?subject=Vérification%20de%20code'>signalez-le-nous</a>."
    },
    "it": {
      "vs_1": "INTERROGAZIONE DEL REGISTRO PRIMECHEMICAL…",
      "vs_2": "CONTROLLO DELLO STATO DELLA LICENZA…",
      "vs_3": "INCROCIO DEI REGISTRI DI LOTTO…",
      "vs_ok": "CORRISPONDENZA TROVATA ✓",
      "vs_ko": "NESSUNA CORRISPONDENZA",
      "vr_ok": "LICENZA VERIFICATA",
      "vr_ko": "CODICE NON TROVATO",
      "vr_code": "Codice di registrazione",
      "vr_brand": "Brand in licenza",
      "vr_prod": "Prodotto",
      "vr_tech": "Tecnologia",
      "vr_status": "Stato della licenza",
      "vr_active": "ATTIVA",
      "vr_since": "In licenza dal",
      "vr_oknote": "Questo prodotto è autorizzato a portare il sigillo indicato. Purezza e identità dell'ingrediente in licenza sono controllate lotto per lotto.",
      "vr_konote": "Questo codice non è nel nostro registro licenze. Controlla la digitazione — e se il prodotto mostra uno dei nostri sigilli con questo codice, <a href='mailto:licence@primechemicalcorp.com?subject=Verifica%20codice'>segnalacelo</a>."
    }
  };

  function T() {
    var l = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
    return STR[l] || STR.en;
  }


  /* Textos de la pagina en los 4 idiomas (la home los tiene en su propio
     diccionario; aqui viajan con la pagina para no depender del tema). */
  var PAGE = {
    "en": {
      "lr_ac": "ACTIVE",
      "lr_ac2": "ACTIVE",
      "lr_ac3": "ACTIVE",
      "lr_ac4": "ACTIVE",
      "lr_ac5": "ACTIVE",
      "lr_ac6": "ACTIVE",
      "lr_gds": "Sleep &amp; recovery — licensed across all three PrimeChemical technologies",
      "lr_go": "Verify this license",
      "lr_hsp": "Advanced sports nutrition — licensed across all three PrimeChemical technologies",
      "lr_k": "Public license registry",
      "lr_mb": "Bakery &amp; pastry systems — licensed across all three PrimeChemical technologies",
      "lr_prt": "Sports nutrition — licensed across all three PrimeChemical technologies",
      "lr_qr": "SCAN ON PACK TO VERIFY",
      "lr_sf": "Licensed across all three PrimeChemical technologies",
      "lr_sub": "These brands are licensed to formulate with PrimeChemical technologies and to carry the seal. Every registration code below is live — try it in the verifier.",
      "lr_t": "Licensed &amp; authorized.",
      "lr_t2": "Today.",
      "v_btn": "Verify",
      "v_demo": "Try a demo code",
      "v_hint": "Find the code next to the ingredient seal on the product label.",
      "v_k": "License verification",
      "v_sub": "Every brand licensed to use a PrimeChemical technology carries a unique registration code on its packaging. Enter it below to verify the license is genuine and active.",
      "v_t": "Is it really",
      "v_t2": "PRIME inside?"
    },
    "es": {
      "lr_ac": "ACTIVA",
      "lr_ac2": "ACTIVA",
      "lr_ac3": "ACTIVA",
      "lr_ac4": "ACTIVA",
      "lr_ac5": "ACTIVA",
      "lr_ac6": "ACTIVA",
      "lr_gds": "Descanso y recuperación — con licencia en las tres tecnologías PrimeChemical",
      "lr_go": "Verificar esta licencia",
      "lr_hsp": "Nutrición deportiva avanzada — con licencia en las tres tecnologías PrimeChemical",
      "lr_k": "Registro público de licencias",
      "lr_mb": "Sistemas de panadería y pastelería — con licencia en las tres tecnologías PrimeChemical",
      "lr_prt": "Nutrición deportiva — con licencia en las tres tecnologías PrimeChemical",
      "lr_qr": "ESCANEA EN EL ENVASE Y VERIFICA",
      "lr_sf": "Con licencia en las tres tecnologías PrimeChemical",
      "lr_sub": "Estas marcas están licenciadas para formular con tecnologías PrimeChemical y llevar el sello. Todos los códigos de registro de abajo están vivos — pruébalos en el verificador.",
      "lr_t": "Licenciadas y autorizadas.",
      "lr_t2": "Hoy.",
      "v_btn": "Verificar",
      "v_demo": "Probar un código demo",
      "v_hint": "Encontrarás el código junto al sello del ingrediente en la etiqueta del producto.",
      "v_k": "Verificación de licencias",
      "v_sub": "Cada marca licenciada para usar una tecnología PrimeChemical lleva un código de registro único en su envase. Introdúcelo aquí para verificar que la licencia es genuina y está activa.",
      "v_t": "¿De verdad lleva",
      "v_t2": "PRIME dentro?"
    },
    "fr": {
      "lr_ac": "ACTIVE",
      "lr_ac2": "ACTIVE",
      "lr_ac3": "ACTIVE",
      "lr_ac4": "ACTIVE",
      "lr_ac5": "ACTIVE",
      "lr_ac6": "ACTIVE",
      "lr_gds": "Sommeil et récupération — sous licence sur les trois technologies PrimeChemical",
      "lr_go": "Vérifier cette licence",
      "lr_hsp": "Nutrition sportive avancée — sous licence sur les trois technologies PrimeChemical",
      "lr_k": "Registre public des licences",
      "lr_mb": "Systèmes de boulangerie et pâtisserie — sous licence sur les trois technologies PrimeChemical",
      "lr_prt": "Nutrition sportive — sous licence sur les trois technologies PrimeChemical",
      "lr_qr": "SCANNEZ SUR L'EMBALLAGE POUR VÉRIFIER",
      "lr_sf": "Sous licence sur les trois technologies PrimeChemical",
      "lr_sub": "Ces marques sont licenciées pour formuler avec les technologies PrimeChemical et porter le sceau. Chaque code ci-dessous est actif — essayez-le dans le vérificateur.",
      "lr_t": "Licenciées et autorisées.",
      "lr_t2": "Aujourd'hui.",
      "v_btn": "Vérifier",
      "v_demo": "Essayer un code démo",
      "v_hint": "Le code se trouve à côté du sceau de l'ingrédient sur l'étiquette du produit.",
      "v_k": "Vérification de licence",
      "v_sub": "Chaque marque licenciée pour utiliser une technologie PrimeChemical porte un code d'enregistrement unique sur son emballage. Saisissez-le ci-dessous pour vérifier que la licence est authentique et active.",
      "v_t": "Y a-t-il vraiment du",
      "v_t2": "PRIME à l'intérieur ?"
    },
    "it": {
      "lr_ac": "ATTIVA",
      "lr_ac2": "ATTIVA",
      "lr_ac3": "ATTIVA",
      "lr_ac4": "ATTIVA",
      "lr_ac5": "ATTIVA",
      "lr_ac6": "ATTIVA",
      "lr_gds": "Sonno e recupero — in licenza su tutte e tre le tecnologie PrimeChemical",
      "lr_go": "Verifica questa licenza",
      "lr_hsp": "Nutrizione sportiva avanzata — in licenza su tutte e tre le tecnologie PrimeChemical",
      "lr_k": "Registro pubblico delle licenze",
      "lr_mb": "Sistemi per panificazione e pasticceria — in licenza su tutte e tre le tecnologie PrimeChemical",
      "lr_prt": "Nutrizione sportiva — in licenza su tutte e tre le tecnologie PrimeChemical",
      "lr_qr": "SCANSIONA SULLA CONFEZIONE E VERIFICA",
      "lr_sf": "In licenza su tutte e tre le tecnologie PrimeChemical",
      "lr_sub": "Questi brand sono in licenza per formulare con le tecnologie PrimeChemical e portare il sigillo. Ogni codice qui sotto è attivo — provalo nel verificatore.",
      "lr_t": "In licenza e autorizzati.",
      "lr_t2": "Oggi.",
      "v_btn": "Verifica",
      "v_demo": "Prova un codice demo",
      "v_hint": "Trovi il codice accanto al sigillo dell'ingrediente sull'etichetta del prodotto.",
      "v_k": "Verifica delle licenze",
      "v_sub": "Ogni brand con licenza per una tecnologia PrimeChemical porta un codice di registrazione unico sulla confezione. Inseriscilo qui per verificare che la licenza sia autentica e attiva.",
      "v_t": "C'è davvero",
      "v_t2": "PRIME dentro?"
    }
  };

  (function () {
    var l = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
    var d = PAGE[l];
    if (!d) { return; }
    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var k = el.getAttribute('data-i18n');
      if (d[k] !== undefined) { el.innerHTML = d[k]; }
    });
    document.querySelectorAll('[data-i18n-ph]').forEach(function (el) {
      var k = el.getAttribute('data-i18n-ph');
      if (d[k] !== undefined) { el.setAttribute('placeholder', d[k]); }
    });
  }());

  var vIn = document.getElementById('vInput');
  if (!vIn) { return; }
  var vGo = document.getElementById('vGo');
  var vScan = document.getElementById('vScan');
  var vRes = document.getElementById('vResult');
  var vBox = document.getElementById('vBox');
  var CODES = Object.keys(REGISTRY);
  var demoIdx = 0;

  vIn.addEventListener('input', function () {
    var v = vIn.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (v.length > 2) { v = v.slice(0, 2) + '-' + v.slice(2); }
    if (v.length > 7) { v = v.slice(0, 7) + '-' + v.slice(7, 11); }
    vIn.value = v;
  });
  vIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { doVerify(); } });
  var vDemo = document.getElementById('vDemo');
  if (vDemo) {
    vDemo.addEventListener('click', function () {
      vIn.value = CODES[demoIdx++ % CODES.length];
      vIn.focus();
    });
  }
  if (vGo) { vGo.addEventListener('click', doVerify); }

  /* Las tarjetas del registro rellenan el verificador y lo lanzan. */
  document.querySelectorAll('.l-go,.lm-code').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.dataset.code;
      if (!code) { return; }
      var sec = document.getElementById('verify');
      if (sec) { sec.scrollIntoView({ behavior: 'smooth' }); }
      vIn.value = code;
      setTimeout(doVerify, 700);
    });
  });

  function doVerify() {
    var code = vIn.value.trim().toUpperCase();
    if (!code) { vIn.focus(); return; }
    var t = T();
    vRes.style.display = 'none';
    vScan.innerHTML = '';
    vScan.style.display = 'block';
    vBox.classList.add('scanning');
    if (vGo) { vGo.disabled = true; }
    var hit = REGISTRY[code];
    var lines = [t.vs_1, t.vs_2, t.vs_3, hit ? t.vs_ok : t.vs_ko];
    lines.forEach(function (txt, i) {
      setTimeout(function () {
        var d = document.createElement('div');
        d.className = 'ln' + (i === 3 && hit ? ' ok' : '');
        d.textContent = '> ' + txt;
        vScan.appendChild(d);
        requestAnimationFrame(function () { d.classList.add('on'); });
        if (i === 3) { setTimeout(function () { showResult(code, hit); }, 480); }
      }, 460 * i + 260);
    });
  }

  function showResult(code, hit) {
    var t = T();
    if (navigator.vibrate) { try { navigator.vibrate(hit ? [35, 45, 80] : [18]); } catch (e) {} }
    vBox.classList.add('flash');
    setTimeout(function () { vBox.classList.remove('flash'); }, 1000);
    vBox.classList.remove('scanning');
    if (vGo) { vGo.disabled = false; }
    vScan.style.display = 'none';
    if (hit) {
      var seal = document.querySelector('img[alt="' + hit.tech + '"]');
      vRes.className = 'v-result ok';
      vRes.innerHTML = '<div class="vr-head"><span class="vic">\u2713</span>' + t.vr_ok + '</div><div class="vr-body">'
        + (seal ? '<div style="display:flex;justify-content:center;padding:6px 0 14px;border-bottom:1px dashed var(--line);margin-bottom:6px"><img src="' + seal.src + '" alt="" style="height:64px"></div>' : '')
        + '<div class="vr-line"><span>' + t.vr_code + '</span><b>' + code + '</b></div>'
        + '<div class="vr-line"><span>' + t.vr_brand + '</span><b>' + hit.brand + '</b></div>'
        + '<div class="vr-line"><span>' + t.vr_prod + '</span><b>' + hit.product + '</b></div>'
        + '<div class="vr-line"><span>' + t.vr_tech + '</span><b>' + hit.tech + '</b></div>'
        + '<div class="vr-line"><span>' + t.vr_status + '</span><b class="grn">\u25cf ' + t.vr_active + '</b></div>'
        + '<div class="vr-line"><span>' + t.vr_since + '</span><b>' + hit.since + '</b></div>'
        + '</div><div class="vr-note">' + t.vr_oknote + '</div>';
    } else {
      vRes.className = 'v-result ko';
      vRes.innerHTML = '<div class="vr-head"><span class="vic">\u2715</span>' + t.vr_ko + '</div><div class="vr-body">'
        + '<div class="vr-line"><span>' + t.vr_code + '</span><b>' + code + '</b></div>'
        + '</div><div class="vr-note">' + t.vr_konote + '</div>';
    }
    vRes.style.display = 'block';
  }

  /* Enlace profundo desde un QR: /pages/licencias?code=CP-2601-PTK */
  (function () {
    var code = null;
    try { code = new URLSearchParams(location.search).get('code'); } catch (e) {}
    if (!code) {
      var m = (location.hash || '').match(/code=([A-Z0-9-]{6,14})/i);
      if (m) { code = m[1]; }
    }
    if (!code) { return; }
    vIn.value = code.toUpperCase();
    setTimeout(function () {
      var sec = document.getElementById('verify');
      if (sec) { sec.scrollIntoView({ behavior: 'smooth' }); }
      setTimeout(doVerify, 600);
    }, 400);
  }());
}());

/* ---- Reveal on scroll (esta pagina usa layout blog, sin el observer del monolito) ---- */
(function () {
  var els = document.querySelectorAll('.reveal');
  if (!els.length) { return; }
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (e) { e.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
  els.forEach(function (e) { io.observe(e); });
  /* Red de seguridad: si algo falla, nada queda invisible */
  setTimeout(function () {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (e) {
      var r = e.getBoundingClientRect();
      if (r.top < window.innerHeight) { e.classList.add('in'); }
    });
  }, 1500);
}());
